export default __webpack_public_path__ + "static/media/projectNavIcon.36d7a78b.svg";